module.exports = __webpack_public_path__ + "img/check-broke-active.1854379e.svg";